import Api from "~/core/helper/apiHelper";

export function search(data, callback) {
  return Api.post(`search/`, data, callback);
}
